<script setup lang="ts">
import { computed, provide, useId } from 'vue'
import MmIcon from './MmIcon.vue'
import { mmFieldKey } from './field'
const props = defineProps<{ id?: string; label: string; count?: number; max?: number; error?: string; hint?: string }>()
const id = props.id || `mm-field-${useId()}`
const error = computed(() => props.error || '')
const describedBy = computed(() => [props.hint && `${id}-hint`, props.error && `${id}-error`].filter(Boolean).join(' ') || undefined)
provide(mmFieldKey, { id, error, describedBy })
</script>

<template>
  <div class="field">
    <label class="field-label" :for="id">{{ label }}<span v-if="count !== undefined && max !== undefined" class="count" :class="{ over: count > max }">{{ count }} / {{ max }}</span></label>
    <slot :id="id" :described-by="describedBy" :invalid="Boolean(error)" />
    <span v-if="hint" :id="`${id}-hint`" class="field-hint">{{ hint }}</span>
    <span v-if="error" :id="`${id}-error`" class="error-text" role="alert"><MmIcon name="alert" :size="14" />{{ error }}</span>
  </div>
</template>
